import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { adminApi } from '@/services/api';
import { formatNumber } from '@/services/format';
import type { MetricSummary } from '@/types';

export function MetricsPage() {
  const [items, setItems] = useState<MetricSummary[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    (async () => {
      try {
        setItems(await adminApi.metrics());
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Não foi possível carregar as métricas');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="p-8 max-w-[1280px] mx-auto">
      <h1 className="page-h1 mb-8">Métricas</h1>
      {loading && <p className="text-gray-500">A carregar…</p>}
      {error && <p className="text-magni-red-600">{error}</p>}
      {!loading && !error && (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-gray-600 text-left">
              <tr>
                <th className="px-6 py-3 font-semibold">Token</th>
                <th className="px-6 py-3 font-semibold text-right">Clientes</th>
                <th className="px-6 py-3 font-semibold text-right">Quantidade total</th>
                <th className="px-6 py-3 w-1" />
              </tr>
            </thead>
            <tbody>
              {items.map((m) => (
                <tr key={m.id} className="border-t border-gray-100 hover:bg-gray-25">
                  <td className="px-6 py-3 font-mono text-xs">
                    <Link to={`/metrics/${encodeURIComponent(m.token)}`} className="text-magni-red hover:underline">
                      {m.token}
                    </Link>
                  </td>
                  <td className="px-6 py-3 text-right text-gray-800">{formatNumber(m.clientCount)}</td>
                  <td className="px-6 py-3 text-right text-gray-800">{formatNumber(m.totalQuantity)}</td>
                  <td className="px-6 py-3 text-right">
                    <Link to={`/metrics/${encodeURIComponent(m.token)}`} className="material-symbols-outlined text-gray-400 hover:text-gray-700 text-[18px]">arrow_forward</Link>
                  </td>
                </tr>
              ))}
              {items.length === 0 && (
                <tr><td colSpan={4} className="px-6 py-6 text-center text-gray-500">Sem métricas.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
